import React from "react";
import { Modal, Form, Select, Input } from "antd";
const { TextArea } = Input;

const SendContractModal = ({
  visible,
  onOk,
  onCancel,
  form,
  statusOptions,
  selectedStatus,
  selectedStatusOption,
  contractUsersOption,
}) => {
  return (
    <Modal
      title="Send Contract"
      open={visible}
      onOk={() => onOk("Send Contract")}
      onCancel={onCancel}
      okText="Send"
      okButtonProps={{
        style: {
          backgroundColor: "#4E36A3",
          color: "white",
          height: "40px",
          width: "100px",
        },
      }}
      cancelButtonProps={{
        style: {
          color: "#4E36A3",
          height: "40px",
          width: "100px",
        },
      }}
    >
      <Form form={form}>
        <h1 className="font-lg">Please select the status</h1>
        <Form.Item name="status" className="pt-1">
          <Select options={statusOptions} onChange={selectedStatusOption} />
        </Form.Item>

        {selectedStatus !== "EXECUTED" &&
          selectedStatus !== "TRANSACTION_CLOSED" && (
            <>
              <h1 className="font-lg">Edit Right</h1>
              <Form.Item name="agreement_file_edit_permission_user_id">
                <Select options={contractUsersOption} />
              </Form.Item>
            </>
          )}

        <h1 className="font-lg">Remark</h1>
        <Form.Item
          name="remarks"
          className="pt-1"
          rules={[{ required: true, message: "Please enter a value." }]}
        >
          <TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SendContractModal;
